import * as React from "react";
import {Grid, InputLabel, TextField} from "@material-ui/core";
import CommonFieldsSection from "./CommonFieldsSection";

interface IProps {
    data?: any;
    isAmazonCustomer?: any;
}
interface IState {
    healthExternalFHIRId: any,
    externalClientReference: any
}
class OMSpecificSection extends React.Component<IProps, IState> {
    private commonFieldsSection: any;
    constructor(props: IProps) {
        super(props);

    this.state = {
        externalClientReference: 'OM+0b36317d-7e7a-11ee-aa14-0242ac130002',
        healthExternalFHIRId: '4b170d94-d58b-11ee-891b-0a58a9feac02'
    };

    this.handleExternalClientReference = this.handleExternalClientReference.bind(this);
    this.handleHealthExternalFHIRId = this.handleHealthExternalFHIRId.bind(this);

}

    public render() {
        return (
            <Grid item xs={12}>

                <CommonFieldsSection ref={(ref) => this.commonFieldsSection = ref}/>

            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <InputLabel style={{
                        color: "red",
                        fontSize: 18,
                        fontWeight: "bold",
                    }}>OM Specific fields</InputLabel>
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Health external FHIR Id (Required)"
                        variant="outlined"
                        value={this.state.healthExternalFHIRId}
                        onChange={this.handleHealthExternalFHIRId}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="External client reference (Required)"
                        variant="outlined"
                        value={this.state.externalClientReference}
                        onChange={this.handleExternalClientReference}
                    />
                </Grid>

            </Grid>

            </Grid>
        );
    }
    public handleHealthExternalFHIRId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({healthExternalFHIRId: event.target.value})
    }

    public handleExternalClientReference(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({externalClientReference: event.target.value})
    }

    public getState() {
        return this.state;
    }

    public getCommonFieldsSection() {
        return this.commonFieldsSection;
    }

}

export default OMSpecificSection
